// extracted by mini-css-extract-plugin
module.exports = {"container":"login_forgot-module__container--1ICs2","button":"login_forgot-module__button--3GoM3"};